import type { HTMLComponent } from "@commercekit/react";
import { Disclosure } from "@headlessui/react";
import { asText } from "@prismicio/helpers";
import { FaqSliceSliceCategoryFaq } from "prismicio-types";
import HelpCircleIcon from "~/components/icons/HelpCircleIcon";

const CategoryFaq: HTMLComponent<{
  slice: FaqSliceSliceCategoryFaq;
}> = ({ slice }) => {

  return (
    <div className={slice.primary.wrap_with_container ? "container faq-section category-faq" : ""}>
      <div className="mb-5 faq px-sm-0">
        <div className="panel-group">
          <div className="panel panel-default panel-header">
            <div className="panel-heading">
              <h2 className="panel-title">{asText(slice.primary.title)}</h2>
            </div>
          </div>
          {slice.items.map((item) => (
            <Disclosure
              as="div"
              defaultOpen={false}
              key={asText(item.question)}
              className="panel panel-default"
            >
              {({ open }) => (
                <>
                  <Disclosure.Button as="div" className="panel-heading">
                    <h3 className="panel-title">
                      <a>
                        <span className="hexa d-inline-flex align-items-center justify-content-center">
                          <HelpCircleIcon />
                        </span>
                        <span>{asText(item.question)}</span>
                        {/* plus (closed) ⇄ minus (open) — cross-faded in custom.css */}
                        <i className={`arrow${open ? " open" : ""}`}></i>
                      </a>
                    </h3>
                  </Disclosure.Button>

                  <Disclosure.Panel as="div" className="panel-collapse collapse show">
                    <div className="panel-body">
                      <span
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: asText(item.answer) || "",
                        }}
                      ></span>
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default CategoryFaq;
